import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import MUISelect from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MUIMenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

const StyledSelect = styled(MUISelect)`
  ${props => props.theme.typography.subtitle1};
  color: ${props => props.theme.colors.text.primary};
  ${props => props.width && css`width: ${props.width}`};
`;

const StyledInputLabel = styled(InputLabel)`
  ${props => props.theme.typography.subtitle1};
  color: ${props => props.theme.colors.text.secondary};
  &.Mui-focused {
    color: ${props => props.theme.colors.text.secondary};
  }
`;

const StyledFormControl = styled(FormControl)`
  & .MuiInput-underline::after {
      border-bottom: 2px solid ${props => props.theme.colors.text.primary};
    }
`;

const StyledMenuItem = styled(MUIMenuItem)`
  ${props => props.theme.typography.subtitle1};
  color: ${props => props.theme.colors.text.primary};
`;

const Select = ({
  children,
  label,
  onChange,
  required,
  width,
  value,
}) => (
  <StyledFormControl>
    <StyledInputLabel>{label}</StyledInputLabel>
    <StyledSelect
      onChange={onChange}
      width={width}
      value={value}
      required={required}
    >
      { children }
    </StyledSelect>
  </StyledFormControl>
);

Select.propTypes = {
  children: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  width: PropTypes.string,
  value: PropTypes.string.isRequired,
};

Select.defaultProps = {
  required: false,
  width: '250px',
};

export { Select, StyledMenuItem as MenuItem };
